import { render, staticRenderFns } from "./CharterUPRating.vue?vue&type=template&id=2a6f8f02"
import script from "./CharterUPRating.vue?vue&type=script&lang=ts"
export * from "./CharterUPRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports